import React, { useState } from 'react';
import { Button } from './ui/button';
import { hooks } from 'botframework-webchat-component';
import HappinessCard from './cards/HappinessCard';
import WelcomeCard from './cards/WelcomeCard';
import PaymentCard from './cards/PaymentCard';
import HappinessCardArabic from './cards/HappinessCardArabic';
import EasyPayCard from './cards/EasypayCard';
import RedeemCard from './cards/RedeemCard';
import RedeemCardArabic from './cards/RedeemCardArabic';
import { BiBorderRadius } from 'react-icons/bi';
const { usePostActivity, useSendEvent } = hooks;

// Custom components for specific cards
const CustomHeroCard = (props) => (
  <div>
    <h2>Custom Hero Card</h2>
    <p>This is a custom card component with its own style and behavior.</p>
  </div>
);

// Component registry for custom cards
const componentRegistry = {
  surveyCard: HappinessCard,
  surveyCardArabic: HappinessCardArabic,
  welcomeCard: WelcomeCard,
  customHeroCard: CustomHeroCard,
  paymentMethod: PaymentCard,
  easypaycard: EasyPayCard,
  redeemCard: RedeemCard,
  redeemCardArabic: RedeemCardArabic,
};

// Adaptive Card Renderer
const AdaptiveCardRenderer = ({ cardData,setScript,isArabic,id , surveyData,redeemData,disableSend,triggeredby,offerUno,language}) => {

  const submitActivity = usePostActivity();
  const sendEvent = useSendEvent();

  const [formData, setFormData] = useState({});
  const [expandedCards, setExpandedCards] = useState({});

  const handleInputChange = (id, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleToggleShowCard = (id) => {
    setExpandedCards((prevExpanded) => ({
      ...prevExpanded,
      [id]: !prevExpanded[id],
    }));
  };
  console.log('cardDataadapt', cardData);
  console.log('redeemData adapt', redeemData);
  console.log('offerUno adapt', offerUno);
  // Check if the card should use a custom component based on its 'id'
  const renderCard = (card) => {
    const cardId = card.id;
    const CustomComponent = componentRegistry[cardId];
    if (CustomComponent && card.data) {
      console.log('language adapt', cardId);
      if (cardId ==='redeemCard') {
        console.log('redeemData from adapt', redeemData);
        console.log('offerUno from adapt', offerUno);
        console.log('language from adapt', language);
        return (
          <RedeemCard
          setScript={setScript}
          id ={id}
          redeemData={redeemData}
          disableSend={disableSend}
          offerUno={redeemData?.offerUno || offerUno}
          language={redeemData?.language || language}
          />
        );
      }
      else  if (cardId ==='redeemCardArabic') {
        return (
          <RedeemCardArabic
          setScript={setScript}
          id ={id}
          redeemData={redeemData}
          disableSend={disableSend}
          offerUno={redeemData?.offerUno || offerUno}
          language={redeemData?.language || language}
          />
        );
      }
      return (
        <CustomComponent
        // tokenUrl={card.data.tokenURL}
        isArabic={isArabic}
          paymentLink={card.data.paymentURL}
          // payload={JSON.parse(card.data.payload)}
        />
      );
    } else  if (cardId ==='surveyCard') {
      return (
        <HappinessCard

        setScript={setScript}
     id ={id}
     surveyData={surveyData}
     disableSend={disableSend}
     triggeredby={triggeredby}
        />
      );
    }
    else  if (cardId ==='surveyCardArabic') {
      return (
        <HappinessCardArabic
        setScript={setScript}
        id ={id}
        surveyData={surveyData}
        disableSend={disableSend}
        />
      );
    }
    else if (CustomComponent) {
      console.log('CustomComponent from adapt', CustomComponent);
      console.log('card from adapt', card);
      return (
        <CustomComponent
        {...card}

        />
      );
    }
    else {
      return renderDefaultCard(card);
    }
  };



  // Recursive function to render elements from Adaptive Card JSON
  const renderDefaultCard = (card) => {
    const renderElement = (element) => {
      switch (element.type) {
        case 'TextBlock':
          return (
            <div
              style={{
                fontWeight: element.weight || 'normal',
                fontSize: element.size || '14px',
                color: element.color || '#000',
              }}
            >
              {element.text}
            </div>
          );
        case 'Image':
          return (
            <img
              src={element.url}
              alt={element.altText || ''}
              style={{
                width: element.width || '100%',
                height: element.height || 'auto',
                objectFit: 'cover',
              }}
            />
          );
        case 'Action.OpenUrl':
          return (
            <Button style={{backgroundColor: '#007560',borderRadius:'999px', padding:'12px 24px'}} onClick={() => handleAction(element, 'OpenUrl')}>
              {element.title}
            </Button>
          );
        case 'Action.Submit':
          return (
            <Button onClick={() => handleAction(element, 'Submit')}>
              {element.title}
            </Button>
          );
        case 'Action.ShowCard':
          return (
            <div>
              <Button onClick={() => handleToggleShowCard(element.id)}>
                {element.title}
              </Button>
              {expandedCards[element.id] && renderDefaultCard(element.card)}
            </div>
          );
        case 'Input.Text':
          return (
            <input
              type="text"
              placeholder={element.placeholder}
              style={{ width: '100%', padding: '8px', marginBottom: '8px' }}
              onChange={(e) => handleInputChange(element.id, e.target.value)}
            />
          );
        case 'Input.Number':
          return (
            <input
              type="number"
              placeholder={element.placeholder}
              min={element.min}
              max={element.max}
              style={{ width: '100%', padding: '8px', marginBottom: '8px' }}
              onChange={(e) => handleInputChange(element.id, e.target.value)}
            />
          );
        case 'Input.ChoiceSet':
          if (element.style === 'expanded') {
            // Render as radio buttons
            return (
              <div style={{ marginBottom: '16px' }}>
                <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>{element.title}</div>
                {element.choices &&
                  element.choices.map((choice, index) => (
                    <div key={index} style={{ marginBottom: '8px' }}>
                      <label>
                        <input
                          type="radio"
                          name={element.id}
                          value={choice.value}
                          onChange={(e) => handleInputChange(element.id, e.target.value)}
                        />
                        {choice.title}
                      </label>
                    </div>
                  ))}
              </div>
            );
          } else {
            // Render as a dropdown (compact)
            return (
              <div style={{ marginBottom: '16px' }}>
                <label style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                  {element.title}
                </label>
                <select
                  style={{ width: '100%', padding: '8px', marginBottom: '8px' }}
                  onChange={(e) => handleInputChange(element.id, e.target.value)}
                >
                  {element.choices &&
                    element.choices.map((choice, index) => (
                      <option key={index} value={choice.value}>
                        {choice.title}
                      </option>
                    ))}
                </select>
              </div>
            );
          }
        case 'Container':
          return (
            <div style={{ marginBottom: '16px' }}>
              {element.items &&
                element.items.map((child, index) => (
                  <React.Fragment key={index}>
                    {renderElement(child)}
                  </React.Fragment>
                ))}
            </div>
          );
        case 'ColumnSet':
          return (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              {element.columns &&
                element.columns.map((column, index) => (
                  <div key={index} style={{ flex: column.width || '1' }}>
                    {renderElement(column)}
                  </div>
                ))}
            </div>
          );
        case 'Column':
          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              {element.items &&
                element.items.map((child, index) => (
                  <React.Fragment key={index}>
                    {renderElement(child)}
                  </React.Fragment>
                ))}
            </div>
          );
        case 'ActionSet':
          return (
            <div style={{ marginTop: '16px' }}>
              {element.actions &&
                element.actions.map((action, index) => (
                  <React.Fragment key={index}>
                    {renderElement(action)}
                  </React.Fragment>
                ))}
            </div>
          );
        default:
          return null;
      }
    };

    return (
      <>
        <div>
          {card.body &&
            card.body.map((element, index) => (
              <React.Fragment key={index}>{renderElement(element)}</React.Fragment>
            ))}
        </div>
        <div>
          {card.actions &&
            card.actions.map((element, index) => (
              <React.Fragment key={index}>{renderElement(element)}</React.Fragment>
            ))}
        </div>
      </>
    );
  };

  const handleAction = (element, actionType) => {
    if (actionType === 'Submit' && element.data["type"] === "paymentMethod") {
      submitActivity({
        type: 'event',
        name: 'paymentChoiceEvent',
        value: { paymentMethod: element.data["paymentMethod"], ...formData},
        channelId: 'webchat',
      });
    }
    else if (actionType === 'OpenUrl') {
      // Check if this is a login card by examining the URL or card data
      const isLoginCard = element.url?.includes('login') || 
                         element.url?.includes('auth') || 
                         element.data?.type === 'login' ||
                         element.title?.toLowerCase().includes('login');
      
      if (isLoginCard) {
        // Redirect the whole page for login
            window.top.location.href = element.url;

      } else {
        // For non-login URLs, open in new tab as before
        sendEvent({
          type: 'event',
          name: 'openUrl',
          value: { url: element.url },
        });
        window.open(element.url, '_blank');
      }
    }
    else if (actionType === 'Submit') {
      console.log('Submitting data:', formData);
      submitActivity({
        type: 'event',
        name: element.title,
        value: {formData},
        channelId: 'webchat',
      });
    }
  };

  // Use the custom renderer or the default one
  return (
    <div>
      {cardData ? renderCard(cardData) : <div>No card data available</div>}
    </div>
  );
};

export default AdaptiveCardRenderer;
